import { Avatar, Box, Skeleton } from '@mui/material';

export default function AgentConfigSkeleton() {
  return (
    <>
      <Box mb={3}>
        <Skeleton variant='text' width={140} height={40} />
        <Skeleton variant='text' width={420} height={22} sx={{ mt: 0.5 }} />
      </Box>

      <Box bgcolor='background.paper' sx={{ border: '1px solid #F3F3F3' }} padding='24px' borderRadius='4px'>
        <Skeleton variant='text' width={160} height={32} />
        <Skeleton variant='text' width={260} height={20} sx={{ mt: 0.5 }} />

        <Box
          sx={{
            gap: '16px',
            alignItems: 'center',
            marginTop: '16px',
            border: '1px solid #F3F3F3',
            borderRadius: '4px',
            padding: '16px'
          }}
          display={{ xs: 'block', sm: 'flex' }}
        >
          <Avatar sx={{ width: 64, height: 64 }} />

          <Box>
            <Skeleton variant='rounded' width={140} height={36} />

            <Skeleton variant='text' width={300} height={16} sx={{ mt: 1 }} />
          </Box>
        </Box>

        <Box mt={3}>
          <Box mb={3}>
            <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
            <Skeleton variant='text' width={200} height={16} sx={{ mt: 0.5 }} />
          </Box>

          <Box display='grid' gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr' }} gap={3}>
            <Box>
              <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
              <Skeleton variant='text' width={200} height={16} sx={{ mt: 0.5 }} />
            </Box>

            <Box>
              <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
              <Skeleton variant='text' width={200} height={16} sx={{ mt: 0.5 }} />
            </Box>
          </Box>
        </Box>

        <Skeleton variant='text' width={140} height={28} sx={{ mt: 4, mb: 1 }} />

        <Box display='flex' gap={4} mb={3}>
          <Box display='flex' alignItems='center' gap={1}>
            <Skeleton variant='circular' width={20} height={20} />
            <Skeleton variant='text' width={120} height={20} />
          </Box>
          <Box display='flex' alignItems='center' gap={1}>
            <Skeleton variant='circular' width={20} height={20} />
            <Skeleton variant='text' width={120} height={20} />
          </Box>
        </Box>

        <Box border='1px solid #F3F3F3' borderRadius={1} p={2}>
          <Skeleton variant='text' width={140} height={20} sx={{ mb: 1 }} />
          <Skeleton variant='rectangular' height={120} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    </>
  );
}
